import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "./CreateCollection.css";
import "../../css/Icons.css";
import { Button } from "../../ds2/components";
import {
  LinkRecord,
  Collection,
  LinkAppConfig,
  getAppFromUrl,
  getAppLogo,
  getAppLogoFromFilename,
  AddCollectionResourcesContract,
  DriveResource,
  AddGoogleDriveResourcesToCollectionsContract,
  ResourceInfo,
  AddOneDriveResourcesToCollectionContract,
  LinkMetadata,
  MSSite,
  MSDrive,
  AddSharePointResourcesToCollectionContract,
  AddConfluenceResourcesToCollectionContract,
  CurrentlyAdding,
} from "winslow-core";
import { useSelector } from "react-redux";
import {
  CollectionAccessTypes,
  KB_MENUS,
  selectEditingCollection,
  selectLinkRecords,
  selectUIStates,
  selectUser,
  setResourcesSearchText,
  setSelectedEmployeeId,
  setSelectedMenu,
  setSelectedMenuId,
  setSelectedPersonaId,
  setUIStates,
} from "../../redux/features/appData";
import { selectSupportedApps } from "../../redux/features/connectedApps/connectedAppsSlice";
import { findLinkAppConfig } from "winslow-core";
import { toast } from "react-hot-toast";
import { toastFail, toastSuccess } from "../../config";
import {
  apiAddCollectionResources,
  apiAddGoogleDriveResourcesToCollection,
  apiAddOneDriveResourcesToCollection,
  apiAddSharePointResourcesToCollection,
  apiAddConfluenceResourcesToCollection,
} from "../../services/CollectionService";
import { useCoreDataLoader } from "../../hooks/useCoreDataLoader";
import { FolderPicker } from "../folder-picker/FolderPicker";
import { useDispatch } from "react-redux";
import {
  apiGetMetadata,
  apiGetWebsiteLinks,
} from "../../services/ShareService";
import { CollectionUrl, CollectionFolder } from "winslow-core";
import { postMultipleFileUpload } from "../../services/client";
import ModalApplicationNotConnected from "./ModalApplicationNotConnected";
import { apiVerifyAppConnected } from "../../services/UserService";
import { MENUS } from "../config/menus";
import {
  apiGetGoogleDriveFolderResourcesPayload,
  apiGetMSDriveFolderResourcesWithSubfoldersPayload,
  apiGetSharePointFolderResourcesWithSubfoldersPayload,
} from "../../services/DriveService.types";
import {
  apiGetGoogleDriveFolderResources,
  apiGetMSDriveFolderResourcesWithSubfolders,
  apiGetSharePointFolderResourcesWithSubfolders,
} from "../../services/DriveService";
import { getAppLogoFromMimeType } from "winslow-core";
import config from "environment";
import ModalEmbeddingInProgress from "./ModalEmbeddingInProgress";
import { ExistsInCollectionTooltip } from "./ExistsInCollectionTooltip";
import { SharePointSitePicker } from "../sharepoint-site-picker/SharePointSitePicker";
import { SharePointPagesPicker } from "../sharepoint-pages-picker/SharePointPagesPicker";
import { GoogleDrivePicker } from "../google-drive-picker/GoogleDrivePicker";
import ModalWebsiteIngestAlert from "./ModalWebsiteIngestAlert";
import { LinkNotFoundCollectionTooltip } from "./LinkNotFoundCollectionTooltip";
import { ConfluencePicker } from "../confluence-picker/ConfluencePicker";
import ConfluencePagesPicker from "../confluence-pages-picker/ConfluencePagesPicker";
import clipboardCopy from "clipboard-copy";
import { set } from "lodash";
import { PlusIcon } from "lucide-react";

const collectionColors = [
  "#B9B9B9",
  "#86DFD0",
  "#9498FF",
  "#FF839E",
  "#FFB5A4",
];

const MAX_FILE_UPLOAD_SIZE = 20485760;
const MAX_COLLECTION_RESOURCES = 500;
const CONFIG_MAX_URLS = 100;

const ACCEPTABLE_FILES =
  "application/pdf, " +
  "application/msword, " +
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document, " +
  "text/plain, " +
  "text/html, " +
  "text/markdown";

const WEBSITE_CONFIG_DEFTAULT = {
  url: "",
  depth: 2,
  count: 40,
};

export const CreateCollection = () => {
  const { reloadAll } = useCoreDataLoader(true); // don't load but get the reloader

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const storeUser = useSelector(selectUser);
  const supportedApps = useSelector(selectSupportedApps);
  const uiStates = useSelector(selectUIStates);
  const editingCollection = useSelector(selectEditingCollection);
  const linkRecords = useSelector(selectLinkRecords);

  const [collectionUrls, setCollectionUrls] = useState<CollectionUrl[]>([]);
  const [collectionGoogleResources, setCollectionGoogleResources] = useState<
    DriveResource[]
  >([]);
  const [collectionOneDriveResources, setCollectionOneDriveResources] =
    useState<DriveResource[]>([]);

  const [showWebsiteIngestAlert, setShowWebsiteIngestAlert] =
    useState<boolean>(false);

  const [websiteIngestAlertData, setWebsiteIngestAlertData] =
    useState<{} | null>(null);

  const [showConfluencePicker, setShowConfluencePicker] =
    useState<boolean>(false);
  const [showSharePointSitePicker, setShowSharePointSitePicker] =
    useState<boolean>(false);
  const [showConfluencePagePicker, setShowConfluencePagePicker] =
    useState<boolean>(false);
  const [showGoogleDrivePicker, setShowGoogleDrivePicker] =
    useState<boolean>(false);
  const [showSharePointPagesPicker, setShowSharePointPagesPicker] =
    useState<boolean>(false);
  const [sharePointUsingPages, setSharePointUsingPages] =
    useState<boolean>(false);
  const [sharePointDrive, setSharePointDrive] = useState<MSDrive | null>(null);
  const [sharePointSite, setSharePointSite] = useState<MSSite | null>(null);
  const [googleDrive, setGoogleDrive] = useState<MSDrive | null>(null);
  const [confluenceSpace, setConfluenceSpace] = useState<MSDrive | null>(null);

  const [passGoogleDrive, setPassGoogleDrive] = useState<boolean>(false);
  const [collectionSharePointResources, setCollectionSharePointResources] =
    useState<DriveResource[]>([]);
  const [collectionConfluenceResources, setCollectionConfluenceResources] =
    useState<DriveResource[]>([]);
  const [resultsHeader, setResultsHeader] = useState<string>("Files");
  const [resultsSubHeader, setResultsSubHeader] = useState<string>(
    "Your selected files will appear here."
  );

  const [collectionFolders, setCollectionFolders] = useState<
    CollectionFolder[]
  >([]);
  const [newUrl, setNewUrl] = useState<string>("");
  const [newUrlMulti, setNewUrlMulti] = useState<string>("");
  const [websiteConfig, setWebsiteConfig] = useState<{
    url: string;
    depth: number;
    count: number;
  }>(WEBSITE_CONFIG_DEFTAULT);
  const [colorPicked, setColorPicked] = useState<string>(collectionColors[0]);
  const [title, setTitle] = useState<string>("");
  const [description, setDescription] = useState<string>("");
  const [accessType, setAccessType] = useState<CollectionAccessTypes>(
    CollectionAccessTypes.TEAM
  );
  const [existingFileLinkRecords, setExistingFileLinkRecords] = useState<
    LinkRecord[]
  >([]);
  const [showAddUrl, setShowAddUrl] = useState<boolean>(false);
  const [showAddWebsite, setShowAddWebsite] = useState<boolean>(false);
  const [isMultilineInput, setIsMultilineInput] = useState<boolean>(false);

  const [showGoogleModal, setShowGoogleModal] = useState<boolean>(false);
  const [showOneDriveModal, setShowOneDriveModal] = useState<boolean>(false);
  const [showSharePointModal, setShowSharePointModal] =
    useState<boolean>(false);
  const [showConfluenceModal, setShowConfluenceModal] =
    useState<boolean>(false);

  const [showEmbeddingInProgress, setShowEmbeddingInProgress] =
    useState<boolean>(false);

  const [currentlyAdding, setCurrentlyAdding] = useState<CurrentlyAdding>(
    CurrentlyAdding.NONE
  );

  const [openedFromSharepoint, setOpenedFromSharepoint] =
    useState<boolean>(false);

  const [msDriveId, setMSDriveId] = useState<string | undefined>(undefined);

  const [uploadFiles, setUploadFiles] = useState<FileList | null>(null);
  const uploadFileRef = useRef(null);
  const [newCollection, setNewCollection] = useState<Collection | null>(null);

  const parallelURLCount = useRef(0);

  useEffect(() => {
    dispatch(setUIStates({ ...uiStates, folderPickerOpen: false }));
    if (editingCollection) {
      setTitle(editingCollection.title);
      setDescription(
        editingCollection.description ? editingCollection.description : ""
      );
      setAccessType(editingCollection.accessType);
      setColorPicked(editingCollection.color);
    }
  }, []);

  useEffect(() => {
    if (currentlyAdding === CurrentlyAdding.WEBSITE) {
      setResultsHeader("Pages");
      setResultsSubHeader("Your selected pages will appear here.");
    } else if (currentlyAdding === CurrentlyAdding.URLS) {
      setResultsHeader("Pages");
      setResultsSubHeader("Your selected urls will appear here.");
    } else {
      setResultsHeader("Files");
      setResultsSubHeader("Your selected files will appear here.");
    }
  }, [currentlyAdding]);

  // Reset isMultilineInput when showAddUrl changes
  useEffect(() => {
    if (!showAddUrl) {
      setIsMultilineInput(false);
    }
  }, [showAddUrl]);

  // Reset isMultilineInput when config.showUrlMultiInput changes
  useEffect(() => {
    if (!config.showUrlMultiInput) {
      setIsMultilineInput(false);
    }
  }, [config.showUrlMultiInput]);

  const urlExistsAlready = (collection: Collection | null, url: string) => {
    if (!collection) {
      return false;
    }

    if (collection.linkRecords && collection.linkRecords.length > 0) {
      const index = collection.linkRecords.findIndex(
        (linkRecord: LinkRecord) => {
          if (!(linkRecord.links && linkRecord.links[0])) {
            return false;
          }

          return (
            removeTrailingSlash(linkRecord.links[0].url) ===
            removeTrailingSlash(url)
          );
        }
      );

      if (index !== -1) {
        return true;
      }
    }

    return false;
  };

  const removeTrailingSlash = (url: string): string => {
    return url.endsWith("/") ? url.slice(0, -1) : url;
  };

  const handleAddWebsite = async (submitWebsiteConfig: {
    url: string;
    depth: number;
    count: number;
  }) => {
    if (websiteConfig.url.trim() === "") {
      return;
    }

    setCollectionUrls([]);
    toast("Getting information about the website...", toastSuccess);
    const websiteLinkResponse = await apiGetWebsiteLinks({
      url: submitWebsiteConfig.url,
      maxDepth: submitWebsiteConfig.depth,
      maxCount: submitWebsiteConfig.count,
    });

    if (!websiteLinkResponse) {
      toast("No urls found for this website", toastFail);
      return;
    }

    const { links, maxDepthMet, maxCountMet } = websiteLinkResponse;
    toast(`We found found${links.length} urls`, toastSuccess);

    updateWebsiteResponseMessage(links, maxDepthMet, maxCountMet);

    const processingUrls = links
      .map((l) => ({
        url: l,
        title: "loading...",
        linkAppConfig: findLinkAppConfig(l, supportedApps),
        linkFound: true,
      }))
      .filter((l) => l.linkAppConfig !== undefined) as CollectionUrl[];

    setCollectionUrls(processingUrls);

    for (const processingUrl of processingUrls) {
      const metadata = await getUrlMetaData(processingUrl.url);
      let linkFound = true;
      let status = "200";
      let title = "";
      if (metadata === "404" || metadata === "503" || metadata === "500") {
        linkFound = false;
        status = metadata;
      } else {
        title = getResolvedTitle(metadata, processingUrl.url);
      }

      setCollectionUrls((prevCollectionUrls) =>
        prevCollectionUrls.map((item) =>
          item.url === processingUrl.url
            ? { ...item, title, linkFound, status }
            : item
        )
      );
    }
  };

  const normalizeUrl = (incomingUrl: string): string | null => {
    //remove trailing slash
    let url = incomingUrl.endsWith("/")
      ? incomingUrl.slice(0, -1)
      : incomingUrl;
    try {
      new URL(url); // First try with original URL
      return url;
    } catch {
      try {
        // If original fails, try with https:// prefix
        new URL(`https://${url}`);
        return `https://${url}`;
      } catch {
        return null;
      }
    }
  };

  const processURLsWithConcurrency = async (
    urls: string[],
    concurrency = 10
  ) => {
    const results = [];
    const executing = new Set();
    parallelURLCount.current = 0;

    for (const url of urls) {
      parallelURLCount.current++;

      console.log("[CretaeCollection] Processing concurrent URL:", url);

      const promise = getUrlMetaData(url).then((metadata: any) => {
        executing.delete(promise);

        let linkFound = true;
        let status = "200";
        let title = "";

        if (metadata === "404" || metadata === "503" || metadata === "500") {
          linkFound = false;
          status = metadata;
          console.log("[handleMultiUrlInput] URL not found:", url);
        } else {
          title = getResolvedTitle(metadata, url);
          console.log("[handleMultiUrlInput] Got metadata:", {
            url,
            title,
            metadata,
          });
        }

        setCollectionUrls((prevCollectionUrls) =>
          prevCollectionUrls.map((item) =>
            item.url === url ? { ...item, title, linkFound, status } : item
          )
        );

        return metadata;
      });

      results.push(promise);
      executing.add(promise);

      if (executing.size >= concurrency) {
        await Promise.race(executing);
      }
    }

    return Promise.all(results);
  };

  const handleMultiUrlInput = async (inputValue: string) => {
    const MAX_URLS = 1000;
    console.log("[handleMultiUrlInput] Starting with raw input:", inputValue);

    // Split and clean the input
    const rawUrls = Array.from(
      new Set(
        inputValue
          .split("\n")
          .map((url) => url.trim())
          .filter((url) => url !== "")
          .map((url) => normalizeUrl(url))
          .filter((url): url is string => url !== null)
      )
    );
    console.log("[handleMultiUrlInput] Cleaned and normalized URLs:", rawUrls);

    // Check if total count including existing URLs would exceed limit
    if (rawUrls.length + collectionUrls.length > MAX_URLS) {
      console.log("[handleMultiUrlInput] Exceeded URL limit:", {
        new: rawUrls.length,
        existing: collectionUrls.length,
        max: MAX_URLS,
      });
      toast(`Cannot exceed ${MAX_URLS} total URLs`, toastFail);
      return;
    }

    // Validate URLs and filter duplicates
    const validUrls: string[] = [];
    let invalidCount = 0;
    let duplicateCount = 0;

    rawUrls.forEach((url) => {
      if (collectionUrls.some((existingUrl) => existingUrl.url === url)) {
        duplicateCount++;
        console.log("[handleMultiUrlInput] Found duplicate URL:", url);
        return;
      }
      validUrls.push(url);
    });

    console.log("[handleMultiUrlInput] Processing results:", {
      validUrls,
      invalidCount,
      duplicateCount,
    });

    // Show errors if any
    if (invalidCount > 0) {
      const message =
        invalidCount === 1 ? "1 URL invalid" : `${invalidCount} URLs invalid`;
      toast(message, toastFail);
    }
    if (duplicateCount > 0) {
      const message =
        duplicateCount === 1
          ? "1 duplicate URL skipped"
          : `${duplicateCount} duplicate URLs skipped`;
      toast(message, toastFail);
    }

    // If no valid URLs, return early
    if (validUrls.length === 0) {
      console.log("[handleMultiUrlInput] No valid URLs to process");
      return;
    }

    // Process valid URLs
    const processingUrls = validUrls.map((url) => {
      const config = findLinkAppConfig(url, supportedApps);
      console.log("[handleMultiUrlInput] Processing URL:", { url, config });

      // Use getAppFromUrl as fallback if findLinkAppConfig returns undefined
      let finalConfig = config;
      if (!config) {
        const appResult = getAppFromUrl(url, supportedApps);
        if (
          appResult !== "NOT_VALID_URL" &&
          appResult !== "APP_CONFIG_NOT_FOUND"
        ) {
          finalConfig = appResult;
        }
      }

      return {
        url,
        title: "loading...",
        linkAppConfig: finalConfig,
        linkFound: true,
      };
    }) as CollectionUrl[];

    console.log(
      "[handleMultiUrlInput] URLs ready for processing:",
      processingUrls
    );

    // Append new URLs to existing collection
    setCollectionUrls((prevUrls) => [...processingUrls, ...prevUrls]);

    // Process URLS concurrently
    await processURLsWithConcurrency(validUrls, 100);
  };

  const updateWebsiteResponseMessage = (
    links: string[],
    maxDepthMet: boolean,
    maxCountMet: boolean
  ) => {
    setWebsiteIngestAlertData({
      urlCount: links.length,
      maxCountMet,
      maxDepthMet,
    });
    setShowWebsiteIngestAlert(true);
  };

  const handleAddUrl = async (incomingUrl: string) => {
    let url = incomingUrl.trim();

    const linkAppConfig = findLinkAppConfig(url, supportedApps);

    if (!linkAppConfig) {
      alert("Invalid url.");
      return;
    }

    // make sure if its a google doc that we can read it
    if (
      linkAppConfig.id === "GOOGLE_DOC" ||
      linkAppConfig.id === "GOOGLE_DRIVE"
    ) {
      const connected = await apiVerifyAppConnected(
        storeUser?.id || "",
        linkAppConfig.id
      );

      if (!connected) {
        setShowGoogleModal(true);
        return;
      }
    }

    // check the existing URLS
    // if (urlExistsAlready(editingCollection, url)) {
    //   toast("URL already in collection.", toastSuccess);
    //   return;
    // }

    // and now in the working set

    if (collectionUrls) {
      const index = collectionUrls.findIndex((cu: CollectionUrl) => {
        return cu.url === url;
      });

      if (index !== -1) {
        toast("Duplicate url.", toastFail);
        return;
      }
    }

    toast("Checking URL", toastSuccess);

    if (!isValidURL(url)) {
      toast("Link is not a valid url...", toastFail);
    }

    let metadata = await getUrlMetaData(url);
    let linkFound = true;
    let status = "200";

    if (metadata === "404" || metadata === "503" || metadata === "500") {
      linkFound = false;
      status = metadata;
      metadata = {
        title: undefined,
      };
    }

    // if (!metadata) {
    //   toast("You don't have access to this URL", toastFail);
    //   return;
    // }

    const title = getResolvedTitle(metadata, url);

    const addedUrl: CollectionUrl = {
      url,
      title,
      linkAppConfig,
      linkFound,
      status,
    };

    setCollectionUrls([addedUrl, ...collectionUrls]);
    setNewUrl("");
    if (collectionUrls.length + 1 === CONFIG_MAX_URLS) {
      setShowAddUrl(false);
    }
  };

  const handleDeleteLink = (deleteUrl: string) => {
    if (!collectionUrls) {
      return;
    }

    const remainingUrls = collectionUrls.filter((url: CollectionUrl) => {
      return url.url !== deleteUrl;
    });

    setCollectionUrls(remainingUrls);
  };

  const handleDeleteUploadFile = (filename: string) => {
    if (!uploadFiles) {
      return;
    }

    const remainingFiles = Array.from(uploadFiles).filter(
      (file: File) => file.name !== filename
    );
    const dataTransfer = new DataTransfer();
    remainingFiles.forEach((file) => dataTransfer.items.add(file));
    setUploadFiles(dataTransfer.files);
  };

  const handleDeleteGoogleLink = (resourceId: string) => {
    if (!collectionGoogleResources) {
      return;
    }

    const remainingUrls = collectionGoogleResources.filter(
      (resource: DriveResource) => {
        return resource.id !== resourceId;
      }
    );

    setCollectionGoogleResources(remainingUrls);

    if (!remainingUrls || remainingUrls.length < 1) {
      setCurrentlyAdding(CurrentlyAdding.NONE);
    }
  };

  const handleDeleteOneDriveLink = (resourceId: string) => {
    if (!collectionOneDriveResources) {
      return;
    }

    const remainingUrls = collectionOneDriveResources.filter(
      (resource: DriveResource) => {
        return resource.id !== resourceId;
      }
    );

    setCollectionOneDriveResources(remainingUrls);

    if (!remainingUrls || remainingUrls.length < 1) {
      setCurrentlyAdding(CurrentlyAdding.NONE);
    }
  };

  const handleDeleteConfluenceLink = (resourceId: string) => {
    if (!collectionConfluenceResources) {
      return;
    }

    const remainingUrls = collectionConfluenceResources.filter(
      (resource: DriveResource) => {
        return resource.id !== resourceId;
      }
    );

    setCollectionConfluenceResources(remainingUrls);

    if (!remainingUrls || remainingUrls.length < 1) {
      setCurrentlyAdding(CurrentlyAdding.NONE);
    }
  };

  const handleDeleteSharePointLink = (resourceId: string) => {
    if (!collectionSharePointResources) {
      return;
    }

    const remainingUrls = collectionSharePointResources.filter(
      (resource: DriveResource) => {
        return resource.id !== resourceId;
      }
    );

    setCollectionSharePointResources(remainingUrls);

    if (!remainingUrls || remainingUrls.length < 1) {
      setCurrentlyAdding(CurrentlyAdding.NONE);
    }
  };

  const handleUrlPaste = async (e: any) => {
    e.preventDefault();
    let newVal = e.clipboardData.getData("Text");

    setNewUrl(newVal);
    await handleAddUrl(newVal);
    setNewUrl("");
  };

  const handleUpdateCollection = async () => {
    if (!storeUser || !storeUser.currentWorkspaceId || !editingCollection) {
      return;
    }

    console.log("[CreateCollection] collectionUrls: ", collectionUrls);

    // add any urls
    if (collectionUrls.length > 0) {
      const payload: AddCollectionResourcesContract["Body"] = {
        collectionId: editingCollection?.id,
        folderId: undefined,
        includeSubfolders: true,
        urls: collectionUrls.filter((r) => r.linkFound),
      };

      toast("Adding resources to collection.", toastSuccess);

      const collection = await apiAddCollectionResources(payload);
      setNewCollection(collection);

      if (!collection) {
        toast("Problem updating collection for resources", toastFail);
        return;
      }
    }

    // add the google drive resources
    if (collectionGoogleResources.length > 0) {
      const payload = {
        userId: storeUser.id,
        collectionId: editingCollection?.id,
        resources: collectionGoogleResources.map((resource: DriveResource) => {
          return {
            resourceId: resource.id,
            folderSlug: resource.folderSlug,
            folderName: resource.folderName,
            completePath: resource.completePath,
            folderRootId: resource.folderRootId,
            mimeType: resource.mimeType,
            url: resource.url,
          } as ResourceInfo;
        }),
      } as AddGoogleDriveResourcesToCollectionsContract["Body"];

      toast("Adding Google drive resources to collection.", toastSuccess);

      const collection = await apiAddGoogleDriveResourcesToCollection(payload);

      if (!collection) {
        toast("Problem updating collection for Google resources", toastFail);
        return;
      }
    }

    if (collectionConfluenceResources.length > 0) {
      const payload = {
        userId: storeUser.id,
        collectionId: editingCollection?.id,
        spaceId: confluenceSpace?.id,
        spaceName: confluenceSpace?.name,
        resources: collectionConfluenceResources.map(
          (resource: DriveResource) => {
            return {
              resourceId: resource.id,
              mimeType: resource.mimeType,
              url: resource.url,
            } as ResourceInfo;
          }
        ),
      } as AddConfluenceResourcesToCollectionContract["Body"];

      toast("Adding Confluence resources to collection.", toastSuccess);

      const collection = await apiAddConfluenceResourcesToCollection(payload);

      if (!collection) {
        toast(
          "Problem updating collection for Confluence resources",
          toastFail
        );
        return;
      }
    }

    // add the one drive resources
    if (collectionOneDriveResources.length > 0) {
      const payload = {
        userId: storeUser.id,
        collectionId: editingCollection?.id,
        driveId: msDriveId || "",
        resources: collectionOneDriveResources.map(
          (resource: DriveResource) => {
            return {
              resourceId: resource.id,
              folderSlug: resource.folderSlug,
              folderName: resource.folderName,
              completePath: resource.completePath,
              folderRootId: resource.folderRootId,
              mimeType: resource.mimeType,
              url: resource.url,
            } as ResourceInfo;
          }
        ),
      } as AddOneDriveResourcesToCollectionContract["Body"];

      toast("Adding OneDrive resources to collection.", toastSuccess);

      const collection = await apiAddOneDriveResourcesToCollection(payload);

      if (!collection) {
        toast("Problem updating collection for OneDrive resources", toastFail);
        return;
      }
    }

    // add the sharepoint resources
    if (collectionSharePointResources.length > 0) {
      const payload = {
        userId: storeUser.id,
        collectionId: editingCollection?.id,
        driveId: sharePointDrive?.id,
        siteId: sharePointSite?.id,
        siteName: sharePointSite?.name,
        resources: collectionSharePointResources.map(
          (resource: DriveResource) => {
            return {
              resourceId: resource.id,
              folderSlug: resource.folderSlug,
              folderName: resource.folderName,
              completePath: resource.completePath,
              folderRootId: resource.folderRootId,
              mimeType: resource.mimeType,
              url: resource.url,
            } as ResourceInfo;
          }
        ),
      } as AddSharePointResourcesToCollectionContract["Body"];

      toast("Adding SharePoint resources to collection.", toastSuccess);

      const collection = await apiAddSharePointResourcesToCollection(payload);

      if (!collection) {
        toast(
          "Problem updating collection for SharePoint resources",
          toastFail
        );
        return;
      }
    }

    setNewCollection(editingCollection);

    // next add the new upload files
    if (uploadFiles) {
      toast("Uploading files.", toastSuccess);
      await uploadFilesForCollection(editingCollection.id);
    }

    // Resources are now embedded individually by the server when they're added
    // Show embedding progress modal to inform user
    setShowEmbeddingInProgress(true);
    dispatch(setSelectedEmployeeId(null));
    dispatch(setSelectedPersonaId(null));
    dispatch(setResourcesSearchText(""));

    // update the collection in redux the ham fisted way
    reloadAll(storeUser.currentWorkspaceId);

    // dispatch(setSelectedMenu(MENUS.COLLECTION_ASK));
    // dispatch(setSelectedMenuId(null));

    // navigate("/waz/collection/" + editingCollection.id + "/ask");
    resetDocuments();
  };

  const handleSaveCollection = async () => {
    if (!storeUser || !storeUser.currentWorkspaceId) {
      return;
    }

    console.log("[handleSave] editingCollection: ", editingCollection);
    if (editingCollection) {
      await handleUpdateCollection();
      return;
    }
  };

  const handleSelectedFolder = async (
    selectedFolder: CollectionFolder,
    includeSubfolders: boolean,
    msDriveId?: string
  ) => {
    dispatch(setUIStates({ ...uiStates, folderPickerOpen: false }));

    if (currentlyAdding === CurrentlyAdding.GOOGLE) {
      toast("Getting Google Drive resources...", toastSuccess);

      const driveResources = await apiGetGoogleDriveFolderResources({
        userId: storeUser?.id,
        folderId: selectedFolder.id,
        includeSubfolders,
      } as apiGetGoogleDriveFolderResourcesPayload);

      if (!driveResources) {
        toast("Problem loading Google Drive resources.", toastFail);
        return;
      }

      console.log("[CreateCollection] handleSelectedFolder: ", driveResources);
      setCollectionGoogleResources([...driveResources]);
    } else if (currentlyAdding === CurrentlyAdding.ONEDRIVE) {
      toast("Getting OneDrive resources...", toastSuccess);
      setMSDriveId(msDriveId);

      const driveResources = await apiGetMSDriveFolderResourcesWithSubfolders({
        userId: storeUser?.id,
        folderId: selectedFolder.id,
        driveId: msDriveId,
        includeSubfolders,
      } as apiGetMSDriveFolderResourcesWithSubfoldersPayload);

      if (!driveResources) {
        toast("Problem loading OneDrive resources.", toastFail);
        return;
      }

      console.log("[CreateCollection] handleSelectedFolder: ", driveResources);
      setCollectionOneDriveResources([...driveResources]);
    } else if (currentlyAdding === CurrentlyAdding.SHAREPOINT) {
      toast("Getting SharePoint resources...", toastSuccess);
      if (!sharePointSite) {
        toast("No SharePoint site selected", toastFail);
        return;
      }
      setMSDriveId(msDriveId);

      const driveResources =
        await apiGetSharePointFolderResourcesWithSubfolders({
          userId: storeUser?.id,
          folderId: selectedFolder.id,
          driveId: msDriveId,
          siteId: sharePointSite.id || "",
          includeSubfolders,
        } as apiGetSharePointFolderResourcesWithSubfoldersPayload);

      if (!driveResources) {
        toast("Problem loading SharePoint resources.", toastFail);
        return;
      }

      console.log("[CreateCollection] handleSelectedFolder: ", driveResources);
      setCollectionSharePointResources([...driveResources]);
    }
  };

  const handleSelectedFiles = (
    resources: DriveResource[],
    msDriveId?: string
  ) => {
    dispatch(
      setUIStates({
        ...uiStates,
        folderPickerOpen: false,
      })
    );

    setPassGoogleDrive(false);

    if (!msDriveId) {
      console.log("[handleSelectedFiles] google drive resources: ", resources);
      setCollectionGoogleResources((prevResources) => [
        ...resources,
        ...prevResources,
      ]);
    } else if (currentlyAdding === "ONEDRIVE") {
      console.log("[handleSelectedFiles] ms drive resources: ", resources);
      setCollectionOneDriveResources((prevResources) => [
        ...resources,
        ...prevResources,
      ]);
      setMSDriveId(msDriveId);
    } else if (currentlyAdding === "SHAREPOINT") {
      console.log(
        "[handleSelectedFiles] sharepoint document resources: ",
        resources
      );
      setCollectionSharePointResources((prevResources) => [
        ...resources,
        ...prevResources,
      ]);
      setMSDriveId(msDriveId);
    }
  };

  const handleAccessChange = (e: any) => {
    setAccessType(e.target.value);
  };

  const handleFileChange = (event: any) => {
    if (!storeUser) {
      return;
    }

    if (event.target.files && event.target.files?.length < 1) {
      return;
    }

    setCurrentlyAdding(CurrentlyAdding.UPLOAD);

    // make sure they are not too big
    for (let i = 0; i < event.target.files.length; i++) {
      if (event.target.files[i].size > MAX_FILE_UPLOAD_SIZE) {
        toast("File is too big! Please keep it under 20MB", toastFail);
        return;
      }
    }

    const filesArray = uploadFiles ? Array.from(uploadFiles) : [];
    if (event.target.files) {
      const newFiles = [
        ...Array.from(event.target.files),
        ...filesArray,
      ] as File[];
      const dataTransfer = new DataTransfer();
      newFiles.forEach((file: File) => dataTransfer.items.add(file as File));
      setUploadFiles(dataTransfer.files);
    }
  };

  const uploadFilesForCollection = async (collectionId: string) => {
    if (!uploadFiles || uploadFiles.length < 1 || !storeUser) {
      return;
    }

    toast("Uploading " + uploadFiles.length + " files...", toastSuccess);

    try {
      const response = await postMultipleFileUpload(
        storeUser.id,
        collectionId,
        uploadFiles
      );

      if (response.status !== 200) {
        toast("Error uploading files " + response.status, toastFail);
      }
    } catch (error) {
      // Handle error
      toast("Error uploading file, please try again.", toastFail);
    }
  };

  const getUrlMetaData = async (url: string): Promise<LinkMetadata | null> => {
    if (!storeUser) {
      return null;
    }

    try {
      const metadata = await apiGetMetadata({ url, userId: storeUser.id });

      console.log("[getUrlMetaData] metadata: ", metadata);

      // Handle error response from API
      if (!metadata) {
        console.log("[getUrlMetaData] No metadata returned for:", url);
        return "404"; // Treat as not found
      }

      return metadata;
    } catch (error) {
      console.error("[getUrlMetaData] Error fetching metadata:", error);
      return "503"; // Service error
    }
  };

  const getUploadFileNames = (): string[] => {
    if (!uploadFiles) {
      return [];
    }

    const files: string[] = [];

    for (let i = 0; i < uploadFiles.length; i++) {
      files.push(uploadFiles[i].name);
    }

    return files;
  };

  const resetDocuments = () => {
    setCollectionUrls([]);
    setCollectionFolders([]);
    setCollectionGoogleResources([]);
    setCollectionOneDriveResources([]);
    setCollectionSharePointResources([]);
    setCollectionConfluenceResources([]);
    setUploadFiles(null);
    setSharePointSite(null);
    setGoogleDrive(null);
    setPassGoogleDrive(false);
    setCurrentlyAdding(CurrentlyAdding.NONE);

    // reset the file input

    if (uploadFileRef.current) {
      const inputButton = uploadFileRef.current as any;
      inputButton.value = "";
    }
  };

  const deleteCollectionFolder = (folderId: string) => {
    const index = collectionFolders.findIndex((folder: CollectionFolder) => {
      return folder.id === folderId;
    });

    if (index !== -1) {
      const newCollectionFolders = [...collectionFolders];
      newCollectionFolders.splice(index, 1);
      setCollectionFolders(newCollectionFolders);
      setCurrentlyAdding(CurrentlyAdding.NONE);
    }
  };

  const handleSelectOneDriveResources = async () => {
    setCurrentlyAdding(CurrentlyAdding.ONEDRIVE);
    setShowAddUrl(false);

    const connected = await apiVerifyAppConnected(
      storeUser?.id || "",
      "MICROSOFT"
    );

    if (!connected) {
      setCurrentlyAdding(CurrentlyAdding.NONE);
      setShowOneDriveModal(true);
      return;
    }

    dispatch(
      setUIStates({
        ...uiStates,
        folderPickerOpen: true,
      })
    );
    setUploadFiles(null);
  };

  const handleSelectSharePointResources = async () => {
    setCurrentlyAdding(CurrentlyAdding.SHAREPOINT);
    setShowAddUrl(false);
    setShowAddWebsite(false);
    setSharePointDrive(null);
    setMSDriveId(undefined);
    setCollectionSharePointResources([]);
    setCollectionConfluenceResources([]);
    setSharePointSite(null);
    setGoogleDrive(null);
    setPassGoogleDrive(false);
    setUploadFiles(null);
    const connected = await apiVerifyAppConnected(
      storeUser?.id || "",
      "MICROSOFT"
    );

    if (!connected) {
      setCurrentlyAdding(CurrentlyAdding.NONE);
      setShowSharePointModal(true);
      return;
    }

    setShowSharePointSitePicker(true);
  };

  const handleSelectGoogleFolder = async () => {
    setCurrentlyAdding(CurrentlyAdding.GOOGLE);
    setShowAddUrl(false);
    setShowAddWebsite(false);
    const connected = await apiVerifyAppConnected(
      storeUser?.id || "",
      "GOOGLE_DRIVE"
    );

    if (!connected) {
      setCurrentlyAdding(CurrentlyAdding.NONE);
      setShowGoogleModal(true);
      return;
    }

    setShowGoogleDrivePicker(true);
    setUploadFiles(null);
  };

  const handleSelectConfluence = async () => {
    setCurrentlyAdding(CurrentlyAdding.CONFLUENCE);
    const connected = await apiVerifyAppConnected(
      storeUser?.id || "",
      "CONFLUENCE"
    );

    if (!connected) {
      setCurrentlyAdding(CurrentlyAdding.NONE);
      setShowConfluenceModal(true);
      return;
    }

    setShowAddUrl(false);
    setShowAddWebsite(false);
    setShowConfluencePicker(true);
    setUploadFiles(null);
  };

  const handleOpenSharepointPicker = () => {
    setOpenedFromSharepoint(false);
    dispatch(
      setUIStates({
        ...uiStates,
        folderPickerOpen: false,
      })
    );
    setShowSharePointPagesPicker(false);
    setSharePointDrive(null);
    setMSDriveId(undefined);
    setShowSharePointSitePicker(true);
    setUploadFiles(null);
  };

  const handleOpenConfluencePicker = () => {
    dispatch(
      setUIStates({
        ...uiStates,
        folderPickerOpen: false,
      })
    );
    setShowConfluencePicker(true);
    setConfluenceSpace(null);
    setConfluenceSpace(null);
    setUploadFiles(null);
  };

  const handleSelectedSharePointSite = (
    mssite: MSSite,
    msdrive: MSDrive | null
  ) => {
    console.log("[handleSelectedSharePointSite] mssite: ", mssite);
    console.log("[handleSelectedSharePointSite] drive: ", msdrive);

    setShowSharePointSitePicker(false);
    setSharePointSite({ ...mssite });
    setSharePointUsingPages(!msdrive);
    setOpenedFromSharepoint(true);
    if (msdrive) {
      setSharePointDrive({ ...msdrive });
      dispatch(
        setUIStates({
          ...uiStates,
          folderPickerOpen: true,
        })
      );
    } else {
      setShowSharePointPagesPicker(true);
    }
  };

  const handleSelectedGoogleDrive = (gDrive: MSDrive | null) => {
    console.log("[handleSelectedGoogleDrive] drive: ", gDrive);

    setShowGoogleDrivePicker(false);
    setGoogleDrive(gDrive ? { ...gDrive } : null);

    dispatch(
      setUIStates({
        ...uiStates,
        folderPickerOpen: true,
      })
    );
    setPassGoogleDrive(true);
  };

  const handleSelectedConfluence = (space: MSDrive | null) => {
    console.log("[handleSelectedConfluence] space: ", space);

    setConfluenceSpace(space);
    setShowConfluencePicker(false);
    setShowConfluencePagePicker(true);
  };

  const handleSelectedConfluenceItems = async (items: DriveResource[]) => {
    dispatch(
      setUIStates({
        ...uiStates,
        folderPickerOpen: false,
      })
    );
    toast("Adding Confluence pages...", toastSuccess);
    // Since ConfluencePagesPicker returns pages directly, we can use them as-is
    setCollectionConfluenceResources([...items]);
  };

  const handleSelectedSharePointPages = (pages: DriveResource[]) => {
    setShowSharePointPagesPicker(false);
    setCollectionSharePointResources([...pages]);
  };

  // const handleDeleteExistingFile = (linkRecordId: string) => {
  //   const index = existingFileLinkRecords?.findIndex(
  //     (linkRecord: LinkRecord) => {
  //       return linkRecord.id === linkRecordId;
  //     }
  //   );

  //   if (index !== -1) {
  //     const newFileLinkRecords = [...existingFileLinkRecords];
  //     newFileLinkRecords.splice(index, 1);
  //     setExistingFileLinkRecords(newFileLinkRecords);
  //   }
  // };

  const handleOpenSystemFilePicker = () => {
    if (uploadFileRef?.current) {
      const inputButton = uploadFileRef.current as any;
      setShowAddUrl(false);
      setShowAddWebsite(false);
      inputButton.click();
    }
  };

  const getFallbackTitle = (url: string): string => {
    // Try to extract filename from URL path
    const urlParts = url.split("/");
    const lastPart = urlParts[urlParts.length - 1];

    // Check if the last part looks like a filename (has extension)
    if (lastPart && lastPart.includes(".") && lastPart.length > 1) {
      // Remove query parameters if present
      const filename = lastPart.split("?")[0];
      if (filename && filename.length > 0) {
        return filename;
      }
    }

    // Use the full URL as fallback
    return url;
  };

  const getResolvedTitle = (
    metadata: LinkMetadata | null | undefined,
    url: string
  ): string => {
    // 1st priority: metadata title
    if (
      metadata &&
      typeof metadata === "object" &&
      metadata.title &&
      metadata.title.trim() !== ""
    ) {
      return metadata.title;
    }

    // 2nd priority: filename from URL if it has an extension
    const urlParts = url.split("/");
    const lastPart = urlParts[urlParts.length - 1];

    if (lastPart && lastPart.includes(".") && lastPart.length > 1) {
      // Remove query parameters if present
      const filename = lastPart.split("?")[0];
      if (filename && filename.length > 0) {
        return filename;
      }
    }

    // 3rd priority: the URL itself
    if (url && url.trim() !== "") {
      return url;
    }

    // Last resort: "(title unknown)"
    return "(title unknown)";
  };

  const handleCopyURLResults = async () => {
    let text = "";

    if (collectionUrls && collectionUrls.length > 0) {
      collectionUrls.forEach((url: CollectionUrl) => {
        const fallbackTitle = getFallbackTitle(url.url);
        const titleToUse = url.title || fallbackTitle;
        const strippedTitle = titleToUse.replace(/[^a-zA-Z0-9]/g, "");

        text += `"${url.url}", "${strippedTitle}", ${url.linkFound ? "200" : url.status} \n`;
      });

      // const payload: AddCollectionResourcesContract["Body"] = {
      //   collectionId: editingCollection?.id,
      //   folderId: undefined,
      //   includeSubfolders: true,
      //   urls: collectionUrls.filter((r) => r.linkFound),
      // };
    }

    await clipboardCopy(text);
    toast("URLs data to clipboard", toastSuccess);
  };

  const resourceButtonDisabled = (buttonType: CurrentlyAdding): boolean => {
    if (
      (currentlyAdding === CurrentlyAdding.URLS ||
        currentlyAdding === CurrentlyAdding.WEBSITE) &&
      collectionUrls.length > 0
    ) {
      if (buttonType !== currentlyAdding) {
        return true; // Disable other buttons
      } else {
        // Disable the button itself if collectionUrls is maxed out
        if (collectionUrls.length >= CONFIG_MAX_URLS) {
          return true; // Disable the button
        } else {
          return false; // Enable the button
        }
      }
    } else {
      return false; // Enable buttons in other cases
    }
  };

  const fileExistsInLinkRecords = (filename: string): boolean => {
    const linkNames = linkRecords?.flatMap((linkRecord: LinkRecord) => {
      return linkRecord.links?.map((link) => {
        return link.title;
      });
    });
    const result = linkNames?.findIndex((linkName) => linkName === filename);
    return result !== -1;
  };

  const googleResourceExistsInCollection = (resourceName: string): boolean => {
    return fileExistsInLinkRecords(resourceName);
  };

  const msResourceExistsInCollection = (resourceName: string): boolean => {
    return fileExistsInLinkRecords(resourceName);
  };

  const linkExistsInCollection = (url: string): boolean => {
    const linkUrls = linkRecords?.flatMap((linkRecord: LinkRecord) => {
      return linkRecord.links?.map((link) => {
        return link.url;
      });
    });
    const result = linkUrls?.findIndex((linkUrl) => linkUrl === url);
    return result !== -1;
  };

  const savable =
    collectionUrls.length > 0 ||
    collectionFolders.length > 0 ||
    (uploadFiles && uploadFiles.length > 0) ||
    existingFileLinkRecords.length > 0 ||
    collectionGoogleResources.length > 0 ||
    collectionOneDriveResources.length > 0 ||
    collectionSharePointResources.length > 0 ||
    collectionConfluenceResources.length > 0;
  const filenames = getUploadFileNames();

  // console.log("[CreateCollection] uploadFiles: ", uploadFiles);
  // console.log("[CreateCollection] folders: ", collectionFolders);
  // console.log("[CreateCollection] collectionUrls: ", collectionUrls);
  // console.log("[CreateCollection] editingCollection: ", editingCollection);
  // console.log("[CreateCollection] existingFileLinkRecords: ", existingFileLinkRecords);
  // console.log("[CreateCollection] existing folders: ", existingFolders);

  const isValidURL = (url: string): boolean => {
    try {
      new URL(url); // First try with original URL
      return true;
    } catch {
      try {
        // If original fails, try with https:// prefix
        new URL(`https://${url}`);
        return true;
      } catch {
        return false;
      }
    }
  };

  console.log("Parallel URLs: ", parallelURLCount);
  console.log("Editing Collection: ", editingCollection);

  return (
    <>
      <div id="create-collection">
        <div className="create-collection-header">
          <div className="page-title">
            {/* {editingCollection ? "Edit" : "Create"} Collection */}
            Add Resources
          </div>
          {/* <div className="create-collection-header-left">
            </div> */}
          <div className="create-collection-header-right">
            <div className="create-collection-header-button">
              {savable && (
                <Button
                  variant="secondary"
                  // leftIcon={<PlusIcon size="24"/>}
                  onClick={resetDocuments}>
                  Start Over
                </Button>
              )}
            </div>

            <div className="create-collection-header-button">
              {savable && (
                <Button
                  variant="primary"
                  // leftIcon={<PlusIcon size="24"/>}
                  disabled={!savable}
                  onClick={handleSaveCollection}>
                  Add
                </Button>
              )}
              {/* <button
                className="collections-button"
                disabled={!savable}
                >
                Add Resources
              </button> */}
            </div>
          </div>
        </div>

        <div className="create-collection-body">
          <div className="create-collection-top">
            <div className="create-collection-title">Add Your HR Files</div>
            <div className="create-collection-description">
              Connect and authorize your apps in personal settings.
            </div>

            <div className="create-collection-sources">
              {/* Add OneDrive Folder */}
              <div
                className={
                  resourceButtonDisabled(CurrentlyAdding.ONEDRIVE)
                    ? "create-collection-source-disabled"
                    : "create-collection-source"
                }
                onClick={handleSelectOneDriveResources}>
                <div className="create-collection-source-group">
                  <div className="create-collection-source-icon">
                    <img src="/icons/onedrive.png" alt="OneDrive icon" />
                  </div>
                  <div className="create-collection-group-label">OneDrive</div>
                </div>
              </div>

              {/* Add SharePoint Resource */}
              <div
                className={
                  resourceButtonDisabled(CurrentlyAdding.SHAREPOINT)
                    ? "create-collection-source-disabled"
                    : "create-collection-source"
                }
                onClick={handleSelectSharePointResources}>
                <div className="create-collection-source-group">
                  <div className="create-collection-source-icon">
                    <img src="/icons/sharepoint.png" alt="SharePoint icon" />
                  </div>
                  <div className="create-collection-group-label">
                    SharePoint
                  </div>
                </div>
              </div>

              {/* Add Google Folder */}
              <div
                className={
                  resourceButtonDisabled(CurrentlyAdding.GOOGLE)
                    ? "create-collection-source-disabled"
                    : "create-collection-source"
                }
                onClick={handleSelectGoogleFolder}>
                <div className="create-collection-source-group">
                  <div className="create-collection-source-icon">
                    <img src="/icons/googledrive.png" alt="Google Drive icon" />
                  </div>
                  <div className="create-collection-group-label">
                    Google Drive
                  </div>
                </div>
              </div>

              {/* Add Confluence */}
              <div
                className={
                  resourceButtonDisabled(CurrentlyAdding.CONFLUENCE)
                    ? "create-collection-source-disabled"
                    : "create-collection-source"
                }
                onClick={handleSelectConfluence}>
                <div className="create-collection-source-group">
                  <div className="create-collection-source-icon">
                    <img src="/icons/confluence.svg" alt="Confluence icon" />
                  </div>
                  <div className="create-collection-group-label">
                    Confluence
                  </div>
                </div>
              </div>

              {/* file uploads */}
              <div
                className={
                  resourceButtonDisabled(CurrentlyAdding.UPLOAD)
                    ? "create-collection-source-disabled"
                    : "create-collection-source"
                }
                onClick={() => {
                  setCurrentlyAdding(CurrentlyAdding.NONE);
                  handleOpenSystemFilePicker();
                }}>
                <div className="create-collection-source-group">
                  <div className="create-collection-source-icon">
                    <img src="/icons/upload.svg" alt="Upload icon" />
                  </div>
                  <div className="create-collection-group-label">Upload</div>

                  <div className="create-collection-folder-select">
                    <input
                      type="file"
                      multiple={true}
                      accept={ACCEPTABLE_FILES}
                      onChange={handleFileChange}
                      onError={(event) => console.log("onError", event)}
                      ref={uploadFileRef}
                      title="Upload Files"
                    />
                  </div>
                </div>
              </div>

              <div
                className={
                  resourceButtonDisabled(CurrentlyAdding.URLS)
                    ? "create-collection-source-disabled"
                    : "create-collection-source"
                }
                onClick={() => {
                  setShowAddUrl(!showAddUrl);
                  setShowAddWebsite(false);
                  setUploadFiles(null);
                  if (!showAddUrl || collectionUrls.length > 0) {
                    setCurrentlyAdding(CurrentlyAdding.URLS);
                  }

                  if (showAddUrl && collectionUrls.length === 0) {
                    setCurrentlyAdding(CurrentlyAdding.NONE);
                  }
                }}>
                <div className="create-collection-source-group">
                  <div className="create-collection-source-icon">
                    <img src="/icons/url.svg" alt="URL icon" />
                  </div>
                  <div className="create-collection-group-label">URL</div>
                </div>
              </div>

              {config.showWebsiteIngest && (
                <div
                  className={
                    resourceButtonDisabled(CurrentlyAdding.WEBSITE)
                      ? "create-collection-source-disabled"
                      : "create-collection-source"
                  }
                  onClick={() => {
                    setUploadFiles(null);
                    setShowAddWebsite(!showAddWebsite);
                    setShowAddUrl(false);
                    if (!showAddWebsite || collectionUrls.length > 0) {
                      setCurrentlyAdding(CurrentlyAdding.WEBSITE);
                    }

                    if (showAddWebsite && collectionUrls.length === 0) {
                      setCurrentlyAdding(CurrentlyAdding.NONE);
                    }
                  }}>
                  <div className="create-collection-source-group">
                    <div className="create-collection-source-icon">
                      <img src="/icons/website.svg" alt="Website icon" />
                    </div>
                    <div className="create-collection-group-label">Website</div>
                  </div>
                </div>
              )}
            </div>
          </div>

          {showAddUrl && (
            <>
              <div className="create-collection-input">
                <div className="row flex-grow">
                  <div className="create-collection-input-text-wrapper">
                    {!isMultilineInput ? (
                      <input
                        className="create-collection-input-text"
                        type="text"
                        placeholder="Enter a URL"
                        value={newUrl}
                        onChange={(e: any) => {
                          setNewUrl(e.target.value);
                        }}
                        onKeyDown={(e: any) => {
                          if (e.key === "Enter") {
                            const normalizedUrl = normalizeUrl(newUrl);
                            if (normalizedUrl) {
                              handleAddUrl(normalizedUrl);
                            } else {
                              toast.error("Invalid URL");
                            }
                          }
                        }}
                        onPaste={handleUrlPaste}
                      />
                    ) : (
                      <textarea
                        className="create-collection-input-textarea"
                        placeholder="Enter multiple URLs separated by new lines"
                        value={newUrlMulti}
                        onChange={(e) => {
                          setNewUrlMulti(e.target.value);
                        }}
                      />
                    )}
                  </div>
                  {config.showUrlMultiInput && (
                    <div
                      className="button-group"
                      style={{
                        marginLeft: "8px",
                        display: "flex",
                        flexDirection: "column",
                        gap: "8px",
                      }}>
                      <Button
                        variant="secondary"
                        size="sm"
                        onClick={() => {
                          setIsMultilineInput(!isMultilineInput);
                        }}
                        style={{ minWidth: "120px" }}>
                        {isMultilineInput ? "Single URL" : "Multiple URLs"}
                      </Button>

                      {/* <button
                        className="collections-button"
                        onClick={() => {
                          setIsMultilineInput(!isMultilineInput);
                        }}
                        style={{ minWidth: "120px" }}>
                        {isMultilineInput ? "Single URL" : "Multiple URLs"}
                      </button> */}
                      {isMultilineInput && (
                        <>
                          <Button
                            variant="primary"
                            size="sm"
                            onClick={() => handleMultiUrlInput(newUrlMulti)}
                            style={{ minWidth: "120px" }}>
                            Submit
                          </Button>

                          {/* <button
                            className="collections-button"
                            onClick={() => handleMultiUrlInput(newUrlMulti)}
                            style={{ minWidth: "120px" }}>
                            Submit
                          </button> */}
                        </>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </>
          )}

          {showAddWebsite && (
            <>
              <div className="create-collection-input">
                <div className="row flex-grow">
                  <div className="create-collection-input-text-wrapper">
                    <input
                      className="create-collection-input-text"
                      type="text"
                      placeholder="Enter a Website URL"
                      value={websiteConfig.url}
                      onChange={(e: any) => {
                        setWebsiteConfig({
                          ...websiteConfig,
                          url: e.target.value,
                        });
                      }}
                      onKeyDown={(e: any) => {
                        if (e.key === "Enter") {
                          handleAddWebsite(websiteConfig);
                        }
                      }}
                    />
                  </div>
                  <div className="number-input-container">
                    <div className="number-input-label">Depth</div>
                    <input
                      className="number-input"
                      title="max-depth-input"
                      type="number"
                      name="max-depth"
                      id="max-depth"
                      placeholder="Depth"
                      value={websiteConfig.depth}
                      max={10}
                      min={1}
                      onChange={(e) => {
                        setWebsiteConfig({
                          ...websiteConfig,
                          depth: parseInt(e.target.value),
                        });
                      }}
                    />
                  </div>

                  <div className="number-input-container">
                    <div className="number-input-label">Count</div>
                    <input
                      className="number-input"
                      title="max-count-input"
                      type="number"
                      name="max-count"
                      id="max-count"
                      placeholder="Link Count"
                      value={websiteConfig.count}
                      max={100}
                      min={1}
                      onChange={(e) => {
                        setWebsiteConfig({
                          ...websiteConfig,
                          count: parseInt(e.target.value),
                        });
                      }}
                    />
                  </div>
                  <div>
                    <Button
                      variant="primary"
                      disabled={!isValidURL(websiteConfig.url.trim())}
                      onClick={() => {
                        handleAddWebsite(websiteConfig);
                      }}>
                      Crawl
                    </Button>

                    {/* <button
                      className="collections-button"
                      disabled={!isValidURL(websiteConfig.url.trim())}
                      onClick={() => {
                        handleAddWebsite(websiteConfig);
                      }}>
                      Crawl
                    </button> */}
                  </div>
                </div>
              </div>
            </>
          )}

          {/* </div> */}

          <div className="create-collection-bottom">
            <div className="row" style={{ gap: "8px", alignItems: "center" }}>
              <div className="create-collection-title">{resultsHeader}</div>
              {collectionUrls &&
                collectionUrls.length > 0 &&
                parallelURLCount.current && (
                  <span>
                    {parallelURLCount.current} parallel requests of{" "}
                    {collectionUrls.length}
                  </span>
                )}
              {collectionUrls.length > 1 && (
                <>
                  <Button
                    variant="secondary"
                    size="md"
                    onClick={handleCopyURLResults}
                    // style={{ minWidth: "120px" }}>
                  >
                    Copy Results
                  </Button>
                  <Button
                    variant="secondary"
                    size="md"
                    onClick={() => {
                      setCollectionUrls([]);
                    }}>
                    Clear
                  </Button>
                </>
              )}
            </div>
            {!savable && (
              <div className="create-collection-zero">{resultsSubHeader}</div>
            )}

            {collectionFolders.length > 0 && (
              <>
                {/* <div className="create-collection-label">
                  Folders
                </div> */}
                <div className="create-collection-new-folders">
                  {collectionFolders.map(
                    (collectionFolder: CollectionFolder) => {
                      return (
                        <div className="create-collection-folder-container">
                          <img src="/icons/folder.svg" alt="" />
                          {collectionFolder.displayName}
                          <div
                            className="create-collection-folder-delete"
                            onClick={() =>
                              deleteCollectionFolder(collectionFolder.id)
                            }>
                            <img className="icon-close" alt="" />
                          </div>
                        </div>
                      );
                    }
                  )}
                </div>
              </>
            )}

            {uploadFiles && (
              <>
                {/* <div className="create-collection-label">
                  Files to Upload
                </div> */}
                <div className="create-collection-new-files">
                  <div className="create-collection-input">
                    {filenames.map((filename: string) => {
                      return (
                        <div className="create-collection-upload-file">
                          {/* <img 
                            className="icon-green-check"
                            style={{cursor: "none"}}
                          /> */}
                          <img
                            src={
                              "/icons/" +
                              storeUser?.theme +
                              "/app_logos/" +
                              getAppLogoFromFilename(filename)
                            }
                            alt={`File type icon for ${filename}`}
                          />

                          <div>{filename}</div>
                          {fileExistsInLinkRecords(filename) && (
                            <ExistsInCollectionTooltip />
                          )}

                          <div
                            className="create-collection-file-delete"
                            onClick={() => {
                              handleDeleteUploadFile(filename);
                            }}>
                            <img className="icon-close" alt="Delete file" />
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </>
            )}

            {collectionUrls.length > 0 && (
              <>
                {/* <div className="create-collection-label">
                  Urls
                </div> */}

                <div className="create-collection-new-urls">
                  {collectionUrls.map((url: CollectionUrl) => {
                    // Use stored linkAppConfig if available, otherwise call getAppFromUrl
                    let result:
                      | LinkAppConfig
                      | "NOT_VALID_URL"
                      | "APP_CONFIG_NOT_FOUND"
                      | undefined = url.linkAppConfig;
                    if (!result) {
                      result = getAppFromUrl(url.url, supportedApps);
                    }
                    console.log("[CreateCollection] result2", result);
                    if (typeof result === "string") {
                      if (
                        result === "NOT_VALID_URL" ||
                        result === "APP_CONFIG_NOT_FOUND"
                      ) {
                        return <></>;
                      }
                    }

                    const lac = result as LinkAppConfig;

                    return (
                      <div className="create-collection-url-container">
                        <div className="create-collection-url-card">
                          <div className="create-collection-url-card-title">
                            <img
                              src={
                                "/icons/" +
                                storeUser?.theme +
                                "/app_logos/" +
                                getAppLogo(
                                  lac.id,
                                  url.title,
                                  supportedApps ? supportedApps : [],
                                  "-activity.svg"
                                )
                              }
                              alt=""
                            />
                            {url.title}
                          </div>
                          {linkExistsInCollection(url.url) && (
                            <ExistsInCollectionTooltip
                              resourceSource={"LINK"}
                            />
                          )}
                          <div className="create-collection-url-card-url">
                            <a href={url.url} target="_blank">
                              {url.url}
                            </a>
                          </div>

                          {!url.linkFound && (
                            <div className="create-collection-url-error">
                              <LinkNotFoundCollectionTooltip
                                status={url.status || "???"}
                              />
                            </div>
                          )}
                          <div
                            className="create-collection-url-delete"
                            onClick={() => {
                              handleDeleteLink(url.url);
                            }}>
                            <img
                              className="icon-close"
                              style={{ width: "24px", height: "24px" }}
                              src="/icons/close.svg"
                              alt="Close"
                            />
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </>
            )}

            {collectionGoogleResources.length > 0 && (
              <>
                {/* <div className="create-collection-label">
                  Urls
                </div> */}

                <div className="create-collection-new-urls">
                  {collectionGoogleResources.map((resource: DriveResource) => {
                    const icon = getAppLogoFromMimeType(resource.mimeType);
                    console.log("[CreateCollection] icon1", icon);
                    let showFolder = true;

                    if (
                      resource.completePath &&
                      resource.completePath.search("/") !== -1
                    ) {
                      showFolder = true;
                    }

                    return (
                      <div className="create-collection-url-container">
                        <div className="create-collection-url-card">
                          <div className="create-collection-url-card-title">
                            <img
                              src={
                                "/icons/" +
                                storeUser?.theme +
                                "/app_logos/" +
                                icon
                              }
                              alt={`File type icon for ${resource.name}`}
                            />
                            {resource.name}
                          </div>
                          {googleResourceExistsInCollection(resource.name) && (
                            <ExistsInCollectionTooltip
                              resourceSource={"LINK"}
                            />
                          )}
                          <div className="create-collection-url-card-url">
                            <a href={resource.url} target="_blank">
                              {resource.url}
                            </a>
                          </div>
                          {showFolder && (
                            <div className="create-collection-resource-folder">
                              in {resource.completePath}
                            </div>
                          )}

                          <div
                            className="create-collection-url-delete"
                            onClick={() => {
                              handleDeleteGoogleLink(resource.id);
                            }}>
                            <img
                              className="icon-close"
                              style={{ width: "24px", height: "24px" }}
                              src="/icons/close.svg"
                              alt="Close"
                            />
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </>
            )}

            {collectionOneDriveResources.length > 0 && (
              <>
                {/* <div className="create-collection-label">
                  Urls
                </div> */}

                <div className="create-collection-new-urls">
                  {collectionOneDriveResources.map(
                    (resource: DriveResource) => {
                      const icon = getAppLogoFromMimeType(resource.mimeType);
                      console.log("[CreateCollection] icon3", icon);
                      let showFolder = true;

                      if (
                        resource.completePath &&
                        resource.completePath.search("/") !== -1
                      ) {
                        showFolder = true;
                      }

                      return (
                        <div className="create-collection-url-container">
                          <div className="create-collection-url-card">
                            <div className="create-collection-url-card-title">
                              <img
                                src={
                                  "/icons/" +
                                  storeUser?.theme +
                                  "/app_logos/" +
                                  icon
                                }
                                alt={`File type icon for ${resource.name}`}
                              />
                              {resource.name}
                            </div>
                            {msResourceExistsInCollection(resource.name) && (
                              <ExistsInCollectionTooltip
                                resourceSource={"LINK"}
                              />
                            )}
                            <div className="create-collection-url-card-url">
                              <a
                                href={resource.url}
                                target="_blank"
                                rel="noreferrer">
                                {resource.url}
                              </a>
                            </div>
                            {showFolder && (
                              <div className="create-collection-resource-folder">
                                in {resource.completePath}
                              </div>
                            )}

                            <div
                              className="create-collection-url-delete"
                              onClick={() => {
                                handleDeleteOneDriveLink(resource.id);
                              }}>
                              <img
                                className="icon-close"
                                style={{ width: "24px", height: "24px" }}
                                src="/icons/close.svg"
                                alt="Close"
                              />
                            </div>
                          </div>
                        </div>
                      );
                    }
                  )}
                </div>
              </>
            )}

            {collectionSharePointResources.length > 0 && (
              <>
                <div className="create-collection-new-urls">
                  {collectionSharePointResources.map(
                    (resource: DriveResource) => {
                      const icon = getAppLogoFromMimeType(resource.mimeType);
                      console.log("[CreateCollection] icon4", icon);
                      let showFolder = true;

                      if (
                        resource.completePath &&
                        resource.completePath.search("/") !== -1
                      ) {
                        showFolder = true;
                      }

                      return (
                        <div className="create-collection-url-container">
                          <div className="create-collection-url-card">
                            <div className="create-collection-url-card-title">
                              {sharePointUsingPages && (
                                <img src={"/icons/" + icon} alt="" />
                              )}
                              {!sharePointUsingPages && (
                                <img
                                  src={
                                    "/icons/" +
                                    storeUser?.theme +
                                    "/app_logos/" +
                                    icon
                                  }
                                  alt={`File type icon for ${resource.name}`}
                                />
                              )}
                              {resource.name}
                              {sharePointUsingPages ? ".aspx" : ""}
                            </div>
                            {msResourceExistsInCollection(resource.name) && (
                              <ExistsInCollectionTooltip
                                resourceSource={"LINK"}
                              />
                            )}
                            <div className="create-collection-url-card-url">
                              <a href={resource.url} target="_blank">
                                {resource.url}
                              </a>
                            </div>
                            {sharePointDrive && (
                              <div className="create-collection-resource-folder">
                                in {sharePointSite?.name}&gt;
                                {resource.completePath}
                              </div>
                            )}
                            {!sharePointDrive && (
                              <div className="create-collection-resource-folder">
                                in {sharePointSite?.name}
                              </div>
                            )}

                            <div
                              className="create-collection-url-delete"
                              onClick={() => {
                                handleDeleteSharePointLink(resource.id);
                              }}>
                              <img
                                className="icon-close"
                                style={{ width: "24px", height: "24px" }}
                                src="/icons/close.svg"
                                alt="Close"
                              />
                            </div>
                          </div>
                        </div>
                      );
                    }
                  )}
                </div>
              </>
            )}

            {collectionConfluenceResources.length > 0 && (
              <>
                <div className="create-collection-new-urls">
                  {collectionConfluenceResources.map(
                    (resource: DriveResource) => {
                      const icon = getAppLogoFromMimeType(resource.mimeType);
                      console.log("[CreateCollection] icon5", icon);
                      let showFolder = true;

                      if (
                        resource.completePath &&
                        resource.completePath.search("/") !== -1
                      ) {
                        showFolder = true;
                      }

                      return (
                        <div className="create-collection-url-container">
                          <div className="create-collection-url-card">
                            <div className="create-collection-url-card-title">
                              <img src={"/icons/" + icon} alt="" />
                              {resource.name}
                            </div>
                            {msResourceExistsInCollection(resource.name) && (
                              <ExistsInCollectionTooltip
                                resourceSource={"LINK"}
                              />
                            )}
                            <div className="create-collection-url-card-url">
                              <a href={resource.url} target="_blank">
                                {resource.url}
                              </a>
                            </div>
                            {confluenceSpace && (
                              <div className="create-collection-resource-folder">
                                from space {confluenceSpace?.name}
                              </div>
                            )}

                            <div
                              className="create-collection-url-delete"
                              onClick={() => {
                                handleDeleteConfluenceLink(resource.id);
                              }}>
                              <img
                                className="icon-close"
                                style={{ width: "24px", height: "24px" }}
                                src="/icons/close.svg"
                                alt="Close"
                              />
                            </div>
                          </div>
                        </div>
                      );
                    }
                  )}
                </div>
              </>
            )}
          </div>
        </div>
      </div>

      {uiStates.folderPickerOpen &&
        currentlyAdding !== CurrentlyAdding.CONFLUENCE && (
          <FolderPicker
            key="folder-picker"
            isOpen={uiStates.folderPickerOpen}
            onClose={() => {
              setCurrentlyAdding(CurrentlyAdding.NONE);
              dispatch(setUIStates({ ...uiStates, folderPickerOpen: false }));
            }}
            onSelectedFolder={handleSelectedFolder}
            onSelectedFiles={handleSelectedFiles}
            msSiteName={sharePointSite ? sharePointSite.name : null}
            googleDrive={googleDrive}
            msDrive={
              currentlyAdding === "SHAREPOINT" && sharePointDrive
                ? sharePointDrive
                : null
            }
            provider={currentlyAdding}
            handleOpenSharepointPicker={handleOpenSharepointPicker}
          />
        )}

      {showConfluencePagePicker && (
        <ConfluencePagesPicker
          isOpen={showConfluencePagePicker}
          onClose={() => {
            setShowConfluencePagePicker(false);
            setCurrentlyAdding(CurrentlyAdding.NONE);
          }}
          onSelected={handleSelectedConfluenceItems}
          confluenceSpace={confluenceSpace}
          handleOpenConfluencePicker={handleOpenConfluencePicker}
        />
      )}

      {showSharePointSitePicker && (
        <SharePointSitePicker
          isOpen={showSharePointSitePicker}
          onClose={() => {
            setShowSharePointSitePicker(false);
            resetDocuments();
          }}
          onSelected={handleSelectedSharePointSite}
        />
      )}

      {showGoogleDrivePicker && (
        <GoogleDrivePicker
          isOpen={showGoogleDrivePicker}
          onClose={() => {
            setShowGoogleDrivePicker(false);
            resetDocuments();
          }}
          onSelected={handleSelectedGoogleDrive}
        />
      )}

      {showConfluencePicker && (
        <ConfluencePicker
          isOpen={showConfluencePicker}
          onClose={() => {
            setShowConfluencePicker(false);
          }}
          onSelected={handleSelectedConfluence}
        />
      )}

      {showSharePointPagesPicker && (
        <SharePointPagesPicker
          isOpen={showSharePointPagesPicker}
          onClose={() => {
            setShowSharePointPagesPicker(false);
            resetDocuments();
          }}
          onSelected={handleSelectedSharePointPages}
          msSite={sharePointSite}
          handleOpenSharepointPicker={handleOpenSharepointPicker}
        />
      )}

      {showOneDriveModal && (
        <ModalApplicationNotConnected
          isOpen={showOneDriveModal}
          onClose={() => setShowOneDriveModal(false)}
          onContinue={() => {
            dispatch(setSelectedMenu(undefined));
            dispatch(setSelectedMenuId(undefined));
            navigate("/waz/settings/personal?tab=4");
          }}
          appName="Microsoft"
        />
      )}

      {showConfluenceModal && (
        <ModalApplicationNotConnected
          isOpen={showConfluenceModal}
          onClose={() => setShowConfluenceModal(false)}
          onContinue={() => {
            dispatch(setSelectedMenu(undefined));
            dispatch(setSelectedMenuId(undefined));
            navigate("/waz/settings/personal?tab=4");
          }}
          appName="Confluence"
        />
      )}

      {showSharePointModal && (
        <ModalApplicationNotConnected
          isOpen={showSharePointModal}
          onClose={() => {
            setShowSharePointModal(false);
          }}
          onContinue={() => {
            dispatch(setSelectedMenu(undefined));
            dispatch(setSelectedMenuId(undefined));
            navigate("/waz/settings/personal?tab=4");
          }}
          appName="Microsoft"
        />
      )}

      {showGoogleModal && (
        <ModalApplicationNotConnected
          isOpen={showGoogleModal}
          onClose={() => setShowGoogleModal(false)}
          onContinue={() => {
            dispatch(setSelectedMenu(undefined));
            dispatch(setSelectedMenuId(undefined));
            navigate("/waz/settings/personal?tab=4");
          }}
          appName="Google"
        />
      )}

      {showEmbeddingInProgress && (
        <ModalEmbeddingInProgress
          isOpen={showEmbeddingInProgress}
          onClose={() => {
            setShowEmbeddingInProgress(false);
          }}
          onContinue={() => {
            setShowEmbeddingInProgress(false);
            dispatch(setSelectedMenu(MENUS.COLLECTION_RESOURCES));
            dispatch(setSelectedMenuId(null));
            dispatch(
              setUIStates({ ...uiStates, kbSelectedMenu: KB_MENUS.MANAGE })
            );
            navigate("/waz/kb/manage");
          }}
        />
      )}

      {showWebsiteIngestAlert && (
        <ModalWebsiteIngestAlert
          isOpen={showWebsiteIngestAlert}
          onClose={() => setShowWebsiteIngestAlert(false)}
          onContinue={() => setShowWebsiteIngestAlert(false)}
          onCancel={() => {
            setShowWebsiteIngestAlert(false);
            setCollectionUrls([]);
          }}
          data={websiteIngestAlertData}
        />
      )}
    </>
  );
};
